import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=170c30d2&"
import script from "./Pagination.vue?vue&type=script&lang=js&"
export * from "./Pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('170c30d2')) {
      api.createRecord('170c30d2', component.options)
    } else {
      api.reload('170c30d2', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=170c30d2&", function () {
      api.rerender('170c30d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/table-card/Pagination.vue"
export default component.exports